function WeekButton({ weekNumber, weekDate, onWeekClick, selectedWeek, isMobile }){

    return <div className={"font-roboto cursor-pointer items-center text-center " +  (isMobile ? "px-2  " : "px-6 ") }  onClick={() => {onWeekClick(weekNumber)}} >
            <div className= {selectedWeek === weekNumber? "font-bold": "font-normal"} >WEEK {weekNumber} </div>
            <div>{weekDate}</div>
        </div>
}

export default WeekButton;